<template>
	<div>
		<div class="box_all">
			<div class="box_content_one">
				<div class="title_font">{{$t('label_1049')}}</div>
				<div class="Echarts">
					<div id="main" style="width: 600px;height: 270px;"></div>
				</div>
				<div class="title_font">{{$t('label_1050')}}</div>
				<div class="Echarts">
					<div id="mains" style="width: 600px;height: 270px;"></div>
				</div>
			</div>
			<div class="box_content_two">
				<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row border height="270" style="width: 90%;margin:10px 0 10px 0;"
				 :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
					<el-table-column header-align="center" align="center" label="No" type="index" width="50">
					</el-table-column>
					<el-table-column prop="name"  :label="$t('label_593')" align="center" width="200">
					</el-table-column>
					<el-table-column prop="repairNum" :label="$t('label_1051')" align="center">
					</el-table-column>
					<el-table-column prop="repairTime" :label="$t('label_1052')" align="center" width="120">
					</el-table-column>

				</el-table>
				<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime1" highlight-current-row border height="270" style="width: 90%;margin:10px 0 10px 0;"
				 :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
					<el-table-column header-align="center" align="center" label="No" type="index" width="50">
					</el-table-column>
					<el-table-column prop="name"  :label="$t('label_593')" align="center" width="200">
					</el-table-column>
					<el-table-column prop="repairNum" :label="$t('label_1051')" align="center">
					</el-table-column>
					<el-table-column prop="repairTime" :label="$t('label_1052')" align="center" width="120">
					</el-table-column>
				</el-table>
				<!-- <div style="position: absolute;bottom: 30px;left: 30%">
          	<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
          	 @parentMethod="searchPage"></Page>
          </div> -->
			</div>
		</div>
   <!-- 导出
    <exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList" style="width: 100%;height: 100%"
     ref="exportBox"></exportMes> -->
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import tree from "@/components/list/tree/tree";
	import file from "@/assets/js/file/file.js";
	import checkItem from "@/components/list/displayPage/checkItemParam";
	import maintenanceItem from "@/components/list/displayPage/maintenanceItemParam";
	import inspectionItem from "@/components/list/displayPage/inspectionItemParam";
	import electronDocument from "@/components/list/displayPage/electronDocumentParam";
	import partInfo from "@/components/list/displayPage/partInfoParam";
	import common from "@/assets/js/common/common.js";
	import statistics from "@/assets/js/statistics/statistics.js";
	import exportMes from "@/components/list/export/export";
	export default {
		name: "graphicStatistics",
		components: {
			Page,
			calendar,
			tree,
			checkItem,
			maintenanceItem,
			inspectionItem,
			electronDocument,
			partInfo,
			exportMes,
		},
		data() {
			return {
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				tableDataTreeTime: [],
				tableDataTreeTime1: [],
        searchData:{},
        exportTitle: '设备故障统计',
        // name:'',
				Readytime: '',

			}
		},
		methods: {
			newMes(param) {
				this.searchData=param
				this.search();
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param);
			},
			// handleCurrentChangeTree(info) {
			// 	this.tableDataTreeInfo = info;
			// },
			// handleCurrentChangeTreeTime(info) {
			// 	this.tableChooseInfo = info;
			// },
			searchPage(param) {
				let dataParam = {
					beginTime: this.searchData.beginTime,
					endTime: this.searchData.endTime,
					name: this.searchData.name,
					id:this.searchData.id,
					type:this.searchData.type,
				};
				let newParam = Object.assign(param, dataParam);
				statistics.repair1(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.records[0].List2;
						this.tableDataTreeTime1 = data.data.records[0].List1;
						this.myEcharts('main', this.tableDataTreeTime);
						this.myEcharts('mains', this.tableDataTreeTime1);
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			myEcharts(name, data) {
				let Xdata=[];
				let data1=[];
				let data2=[];
				let sum=0;
				if(name=='main'){
					for(let i=0;i<data.length;i++){
						data1.push(data[i].repairNum);
						sum+=data[i].repairNum;
					}
				}else{
					for(let i=0;i<data.length;i++){
						data1.push(data[i].repairTime);
						sum+=data[i].repairTime;
					}
				}
				let x=0;
				for(let i=0;i<data1.length;i++){
					Xdata.push(i+1)
					x+=data1[i];
					data2.push(x/sum*100);
				}

				let myChart = this.$echarts.init(document.getElementById(name));
				//配置图表
				let option = {
					tooltip: {
						trigger: 'axis', //触发类型,坐标轴触发
						transitionDuration: 0,
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: '#999'
							}
						}
					},
					xAxis: [{
						type: 'category',
						data: Xdata,
						axisTick: {
							show: false
						},
						axisLine: {
							show: false
						},
					}],
					yAxis: [{
							type: 'value',
							// min: 0,
							// max: 6000,
							// interval: 1000,
							show:true,
							splitLine:{show:false},
							axisTick:{      //  去掉y轴刻度
							  show:false
							}
						},
						{
							type: 'value',
							name: "（%）",
							nameLocation: 'end',
							min: 0,
							max: 100,
							interval: 10,
						}
					],
					series: [{
							name: (name == 'mains' ? '时长' : '回数'),
							type: 'bar',
							barWidth: 35,
							data: data1,
							itemStyle: { //柱状颜色和圆角
								color: '#5681BF'
							},
							backgroundStyle: {
								color: 'rgba(220, 220, 220, 0.8)'
							},
						},
						{
							name: '百分比',
							type: 'line',
							yAxisIndex: 1,
							data: data2,
							symbol: "circle",
							symbolSize: 3,
							itemStyle: {
								normal: {
									color: '#A9C0E1',
									lineStyle: {
										color: '#A9C0E1'
									}
								}
							},
						}
					]
				}
				myChart.setOption(option);
			},
		},
		mounted() {
		}
	}
</script>

<style>
	.box_all {
		width: 100%;
		display: flex;
	}

	.box_content_one {
		width: 50%;
	}

	.box_content_two {
		width: 50%;
	}

	.title_font {
		font-size: 20px;
		color: #3FB393;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/components/list/tabPane/graphicStatistics.vue